import { GetStaticProps } from "next";
import { useTranslation } from "next-i18next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { NextSeo } from "next-seo";
import { useRouter } from "next/router";
import { getCanonicalAndLanguageAlternates } from "@/utils/seo";
import { Page } from "@/components/Layout";
import { RewardsView } from "@/views";
import { getChainInfo } from "@/utils";

const RewardsPage = () => {
  const { t } = useTranslation();
  const router = useRouter();
  const currentChainInfo = getChainInfo();

  const title = "Rewards";
  const description = "Keep an eye on how many Points you've accumulated in YOLO Games' current season.";
  const { canonical, languageAlternates } = getCanonicalAndLanguageAlternates(
    `/rewards/`,
    router,
    currentChainInfo.appUrl
  );

  return (
    <Page title={title}>
      <NextSeo
        noindex
        nofollow
        title={title}
        description={description}
        openGraph={{
          url: canonical,
          title: t("{{pageTitle}} | YOLO Games", { pageTitle: title }),
          description: description,
          images: [
            {
              url: `${currentChainInfo.appUrl}/images/season-2.png`,
              alt: "Rewards",
              width: 1600,
              height: 840,
              type: "image/png",
            },
          ],
        }}
        canonical={canonical}
        languageAlternates={languageAlternates}
      />
      <RewardsView />
    </Page>
  );
};

export const getStaticProps: GetStaticProps = async ({ locale = "en" }) => {
  return {
    props: {
      ...(await serverSideTranslations(locale, ["liq", "common"])),
    },
  };
};

export default RewardsPage;
